import {
  FilterMode,
  SnapshotOverrideCreateMutationVariables,
  SnapshotOverride_OrderBy,
  SnapshotOverride,
  SortOrder,
  SnapshotOverride_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const snapshotOverrideService = {
  createOne: buildCreateOne(
    (
        snapshotOverrideCreateVariables: SnapshotOverrideCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.snapshotOverrideCreate(
          snapshotOverrideCreateVariables
        );
        return result.snapshotOverrideCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.snapshotOverrideOne({ id });
    return result.snapshotOverrideOne as SnapshotOverride;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: SnapshotOverride_OrderBy[] | null = null,
    filter: SnapshotOverride_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: SnapshotOverride_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          {
            relatedEntityId: {
              contains: searchValue,
              mode: FilterMode.Insensitive,
            },
          },
          { path: { contains: searchValue, mode: FilterMode.Insensitive } },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.snapshotOverrideListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ relatedEntityId: SortOrder.Asc }, { path: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.snapshotOverrideListWithOffset
    ) as SnapshotOverride[];
    return { list, orderBy };
  },
};
